import { animate, scroll } from 'motion';

// Create anchor links for each section and add them to subnavigation
const sections = document.querySelectorAll('.page-content > section:not(:first-child)');
const subnav = document.querySelector('.subnav');
const subnavLinks = document.querySelectorAll('.subnav a');
const subnavMobileTriggers = document.querySelectorAll('.subnav__link--mobile-trigger');

if (sections.length > 0) {
	const isMobile = window.matchMedia('(max-width: 768px)').matches;

	const removeMobileActiveClass = () => {
		document.querySelectorAll('.subnav__link--mobile-active').forEach((item) => {
			item.classList.remove('subnav__link--mobile-active');
		});
	};

	// Calculate the progress for each section and update the CSS variable
	subnavLinks.forEach((link) => {
		const section = document.getElementById(link.getAttribute('href').replace('#', ''));
		const highlight = link.querySelector('.subnav__link--highlight');

		scroll(
			animate(highlight, {
				width: ['0%', '100%'],
			}),
			{
				target: section,
				offset: ['start end', 'start 172px'],
			}
		);
		// Set the CSS variable for progress in the subnavigation link
	});

	if (isMobile) {
		subnavLinks.forEach((link) => {
			link.addEventListener('click', function () {
				subnav.classList.remove('subnav--active');

				// Match 'data-id' attributes for mobile trigger and subnav nav
				const dataId = link.getAttribute('data-id');
				const correspondingTriggerLink = document.querySelector(
					`.subnav__link--mobile-trigger[data-id="${dataId}"]`
				);

				removeMobileActiveClass();

				if (correspondingTriggerLink) {
					correspondingTriggerLink.classList.add('subnav__link--mobile-active');
				}
			});
		});

		subnavMobileTriggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				subnav.classList.toggle('subnav--active');
			});
		});

		const closeSubnav = (e) => {
			if (!e.target.classList.contains('subnav__link')) {
				subnav.classList.remove('subnav--active');
			}
		};

		window.addEventListener('click', closeSubnav);
	}
}
